import { observable } from "mobx";
import KioskDisplayStatus from "./kioskDisplayStatus";
import KioskPurchaseStatus from "./kioskPurchaseStatus";
import Enum from "./enum";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class Kiosk extends Enum {
  id!: string;

  @observable
  name!: string;

  @observable
  purchaseStatus!: KioskPurchaseStatus;

  @observable
  displayStatus!: KioskDisplayStatus;
}
